/* tslint:disable */
/* eslint-disable */
/**
 * Credify API doc version 2
 * API documentations version 2.
 *
 * The version of the OpenAPI document: 1.0.0-oas3
 * Contact: dev@credify.one
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { BackupClaims } from '../model';
// @ts-ignore
import { BackupClaims200Response } from '../model';
// @ts-ignore
import { GetClaimBackup200Response } from '../model';
/**
 * VaultApi - axios parameter creator
 * @export
 */
export const VaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This stores encrypted claims in vault.
         * @summary Backup claims
         * @param {BackupClaims} [backupClaims] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        backupClaims: async (backupClaims?: BackupClaims, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/private/entity/claims`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = backupClaims

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This retrieves encrypted claims from vault.
         * @summary Gets claim backup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimBackup: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/private/entity/claims`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VaultApi - functional programming interface
 * @export
 */
export const VaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VaultApiAxiosParamCreator(configuration)
    return {
        /**
         * This stores encrypted claims in vault.
         * @summary Backup claims
         * @param {BackupClaims} [backupClaims] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async backupClaims(backupClaims?: BackupClaims, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackupClaims200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.backupClaims(backupClaims, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This retrieves encrypted claims from vault.
         * @summary Gets claim backup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClaimBackup(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetClaimBackup200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClaimBackup(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VaultApi - factory interface
 * @export
 */
export const VaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VaultApiFp(configuration)
    return {
        /**
         * This stores encrypted claims in vault.
         * @summary Backup claims
         * @param {BackupClaims} [backupClaims] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        backupClaims(backupClaims?: BackupClaims, options?: any): AxiosPromise<BackupClaims200Response> {
            return localVarFp.backupClaims(backupClaims, options).then((request) => request(axios, basePath));
        },
        /**
         * This retrieves encrypted claims from vault.
         * @summary Gets claim backup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimBackup(options?: any): AxiosPromise<GetClaimBackup200Response> {
            return localVarFp.getClaimBackup(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VaultApi - interface
 * @export
 * @interface VaultApi
 */
export interface VaultApiInterface {
    /**
     * This stores encrypted claims in vault.
     * @summary Backup claims
     * @param {BackupClaims} [backupClaims] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultApiInterface
     */
    backupClaims(backupClaims?: BackupClaims, options?: AxiosRequestConfig): AxiosPromise<BackupClaims200Response>;

    /**
     * This retrieves encrypted claims from vault.
     * @summary Gets claim backup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultApiInterface
     */
    getClaimBackup(options?: AxiosRequestConfig): AxiosPromise<GetClaimBackup200Response>;

}

/**
 * VaultApi - object-oriented interface
 * @export
 * @class VaultApi
 * @extends {BaseAPI}
 */
export class VaultApi extends BaseAPI implements VaultApiInterface {
    /**
     * This stores encrypted claims in vault.
     * @summary Backup claims
     * @param {BackupClaims} [backupClaims] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultApi
     */
    public backupClaims(backupClaims?: BackupClaims, options?: AxiosRequestConfig) {
        return VaultApiFp(this.configuration).backupClaims(backupClaims, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This retrieves encrypted claims from vault.
     * @summary Gets claim backup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultApi
     */
    public getClaimBackup(options?: AxiosRequestConfig) {
        return VaultApiFp(this.configuration).getClaimBackup(options).then((request) => request(this.axios, this.basePath));
    }
}
